if (![].at) {
  Array.prototype.at = function (this: Array<unknown>, pos: number) {
    return this.slice(pos, pos + 1)[0]
  }
}
